module.exports = __webpack_public_path__ + "img/logo-seadevil-highlight.3fe3b147.png";